module.exports = __webpack_public_path__ + "img/activecommu.0e677eda.svg";